import React from 'react';
import ReactDOM from 'react-dom';
import { AfeQuickCheckApp } from 'components/react/AfeQuickCheck/AfeQuickCheckApp';

// Globally enable or disable the application but on positive result.
// Used if the application range is not available anymore.
// ...
// IDEA: Set this in the TYPO3 content element for easy usage.
// ...
// eslint-disable-next-line max-len
window.DISABLE_AFE_QUICKCHECK_APPLICATION_BTN = !window.ENABLE_AFE_QUICKCHECK_APPLICATION_BTN || false;

// Initialize the Arthur-Fischer-Enfinderpreis Quick Check App
const afeDomNode = document.getElementById('afe-quick-check-app');
if (afeDomNode !== null) {
  ReactDOM.render(<AfeQuickCheckApp/>, afeDomNode);
}
